import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MediaObserver } from '@angular/flex-layout';
import { AuthService } from 'src/app/services';

@Component({
  selector: 'esc-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {

  public isPasswordShown: boolean;
  public form: FormGroup;
  public errorMessage: String;
  public versionMismatch;
  public key;
  @Input() consolidatorList: any;
  @Input() isSubmitting: any;
  @Input() imgUrl: string;
  @Output() onWarehouseSelect = new EventEmitter<boolean>();

  constructor(
    private fb: FormBuilder,
    public media: MediaObserver,
    public authService: AuthService,
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      consolidator: [ null,
        Validators.compose([
          Validators.required
        ])
      ]
    });
  }

  proceed(value) {
    if(this.form.valid){
      this.onWarehouseSelect.emit(this.form.get('consolidator').value);
    }
  }

  back(){
    this.onWarehouseSelect.emit(null);
  }

}
